// import {
//     EASYLEASE,
//     LOCATIONS,
//     SERVICES,
//     TERM_AND_CONDITION,
//     COOKIE_POLICY,
//     FARE_WEAR_AND_TEAR_POLICY,
//     PRAVICY_AND_POLICY,
// } from '../route/AppRouter';

const subscription = {
    header: 'Subscription',
    subHeader: [
        { value: 'Start a subscription', link: '/vehicle', other: false },
        { value: 'View/Cancel', link: '/profile/detail', other: false },
    ],
};
const vehicles = {
    header: 'The Company',
    subHeader: [{ value: 'About Us', link: '/about-us', other: false }],
};
const easylease = {
    header: 'Easy Lease',
    subHeader: [
        // {value: 'Sign in', link: '/'},
        { value: 'What is Easy Lease?', link: '/easylease', other: false },
        { value: 'How Easy Lease Works', link: '/how-it-works', other: false },
        // {value: 'Locations', link: '/locations', other: false},
        // {value: 'Feedbacks', link: '/feedbacks'},
        { value: 'Terms & Conditions', link: '/terms-and-conditions', other: false },
        // {value: 'Cookie Policy', link: '/policy/cookies'},
        { value: 'Fair Wear & Tear Policy', link: '/fare-ware-and-tear', other: false },
        { value: 'Privacy Policy', link: '/privacy-policy', other: false },
        { value: 'FAQs', link: '/faq', other: false },
        // {value: 'FeedBack', link: '/feed-back'},
    ],
};
const yomaleasing = {
    header: 'Yoma Leasing',
    subHeader: [
        { value: 'Yoma Leasing', link: '/about/easylease', other: false },
        { value: 'Cars', link: '/about/easylease', other: false },
        { value: 'Hubs', link: '/about/easylease', other: false },
        { value: 'Services', link: '/how-it-works', other: false },
        { value: 'Finance Consultant', link: '/about/easylease', other: false },
    ],
};
const operatinglease = {
    header: 'Browse Operating Lease',
    subHeader: [
        { value: 'Yoma Leasing', link: '/about/easylease', other: false },
        { value: 'Cars', link: '/about/easylease', other: false },
        { value: 'Hubs', link: '/about/easylease', other: false },
        { value: 'Services', link: '/how-it-works', other: false },
        { value: 'Finance Consultant', link: '/about/easylease', other: false },
    ],
};
const yomacarshare = {
    header: 'Car Share',
    subHeader: [
        { value: 'Find A Cars', link: 'https://www.yomacarshare.com/reservation/findacar', other: true },
        { value: 'How Easy Lease Works', link: 'https://www.yomacarshare.com/howitworks', other: true },
        { value: 'World Class Drive', link: 'https://www.yomarentals.asia/worldclassdrive', other: true },
        { value: 'Locations', link: 'https://www.yomacarshare.com/locations', other: true },
        { value: 'FAQs', link: 'https://www.yomacarshare.com/faq', other: true },
        { value: 'Sign In', link: 'https://www.yomacarshare.com/login', other: true },
        { value: 'Contact', link: 'https://www.yomacarshare.com/contactus', other: true },
    ],
};
const yomarentalasia = {
    header: 'Truck and Trailer',
    subHeader: [
        { value: 'Find Truck & Trailer', link: 'https://www.yomarentals.asia/reservation/findacar', other: true },
        { value: 'How It Works', link: 'https://www.yomarentals.asia/howitworks', other: true },
        { value: 'Our Fleet', link: 'https://www.yomarentals.asia/meetourfleet', other: true },
        { value: 'Locations', link: 'https://www.yomarentals.asia/locations', other: true },
        { value: 'FAQs', link: 'https://www.yomarentals.asia/faq', other: true },
        { value: 'Sign In', link: 'https://www.yomarentals.asia/login', other: true },
        { value: 'Contact', link: 'https://www.yomarentals.asia/contactus', other: true },
    ],
};
const yomaleasing_main_menu = {
    header: 'Car Sales',
    subHeader: [
        { value: 'Find Vehicles', link: 'https://www.yomaautomart.com/auctionlist/live', other: true },
        { value: 'How It Works', link: 'https://www.yomaautomart.com/how-it-works', other: true },
        { value: 'Contact', link: 'https://www.yomaautomart.com/contact', other: true },
    ],
};
const yomaautomart = {
    header: 'LEASE TO BUY',
    subHeader: [{ value: 'Pricing Calculator', link: 'https://yomaleasing.com/', other: true }],
};

const support = {
    header: 'Support',
    subHeader: [
        { value: 'Contact', link: '/contact', other: false },
        { value: 'Feedback', link: '/feedback', other: false },
        { value: 'Sitemap', link: '/sitemap', other: false },
    ],
};

export {
    subscription,
    vehicles,
    easylease,
    yomaleasing,
    operatinglease,
    yomacarshare,
    yomarentalasia,
    yomaleasing_main_menu,
    yomaautomart,
    support,
};
